import { ApolloError } from '@apollo/client';

import { useErpCareerLessonsQuery } from 'core/graphql';

import { useStableRefetch } from '../Groups/useStableRefetch';
import { ICareerLesson } from './careerModel';

// Stable empty fallback — see the note in `useCareerMembers`.
const EMPTY_LESSONS: ICareerLesson[] = [];

interface ICareerLessonsHook {
  lessons: ICareerLesson[];
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
}

/**
 * Spec 0018 — the Обучение tab (`careerLessonsErp`). The staff view of the
 * single career track: unpublished lessons included, `content` never nulled
 * (the LMS `careerLessons` hides both).
 */
export const useCareerLessons = (): ICareerLessonsHook => {
  const { data, loading, error, refetch } = useErpCareerLessonsQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const stableRefetch = useStableRefetch(refetch);

  return {
    lessons: data?.careerLessonsErp ?? EMPTY_LESSONS,
    loading,
    error,
    refetch: stableRefetch,
  };
};
